import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import AccountCircleSharpIcon from '@mui/icons-material/AccountCircleSharp';
import { IconButton, Box, Typography, TextField } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import { StyledMenu } from './style';
import { ColorsV2 } from 'app/constants/color';
import apiService from 'app/services/apiService';
import appService from 'app/services/appService';
import { useSelector } from 'react-redux';

export default function ProfileDropdown() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [authorities, setAuthorities] = useState([]);
  const [roles, setRoles] = useState([]);
  const [adm, setAdm] = useState('');
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const accountSettings = useSelector((state) => state.updateUser.userData)

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleNavigation = () => {
    navigate('/settings');
    setAnchorEl(null);
  };
  const handleLogout = () => {
    appService.logout();
  };

  const handleChange = async e => {
    const selectedRole = roles.find(role => role.name === e.target.value);
    if (selectedRole) {
      await apiService.setProfile({
        email: accountSettings.email,
        firstName: accountSettings.firstName,
        lastName: accountSettings.lastName,
        phoneNr: accountSettings.phoneNr,
        persNr: accountSettings.persNr,
        role: selectedRole.id,
      });
    }
  };

  const fetchRoles = async () => {
    const res = await apiService.getRoles();
    setRoles(res.data);
  };

  const fetchAuthorities = async () => {
    let res = null;
    try {
      res = await apiService.getAuthorities();
      setAuthorities(res.data);
    }
    catch (error) {
      console.error(error);
    }

  }

  useEffect(() => {
    fetchRoles();
    fetchAuthorities();
  }, []);

  useEffect(() => {
    const isAdmin = authorities.find(
      (auth) => auth.id === accountSettings.auth && auth.level >= 100
    );
    setAdm(isAdmin ? 'admin' : '');
  }, [accountSettings, authorities]);

  const { t } = useTranslation('translation', { keyPrefix: 'profile_popup' });

  return (
    <div>
      <Box
        id='demo-customized-button'
        aria-controls={open ? 'demo-customized-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        sx={{ display: 'flex' }}
      >
        <IconButton disableRipple>
          <AccountCircleSharpIcon fontSize='large' style={{ color: 'white', fontSize: '1.1em' }} />
        </IconButton>
      </Box>
      <StyledMenu
        id='demo-customized-menu'
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{
          '& .MuiPaper-root': {
            borderRadius: '8px',
            marginTop: '8px',
            minWidth: 200,
            backgroundColor: ColorsV2.secondary,
            color: 'white',
            boxShadow:
              'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
            '& .MuiMenu-list': {},
            '& .MuiMenuItem-root': {
              borderRadius: '5px',
              margin: '2px 10px',
              '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: 'black',
                marginRight: '12px',
              },
            },
          },
        }}
      >
        <MenuItem
          onClick={handleNavigation}
          sx={{
            '&:hover': {
              backgroundColor: ColorsV2.acent,
            },
          }}
        >
          <svg
            width='0.7em'
            height='0.7em'
            viewBox='0 0 16 18'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M2.21875 5.06219C2.21875 7.69188 4.37031 9.84344 7 9.84344C9.62969 9.84344 11.7812 7.69188 11.7812 5.06219C11.7812 2.43251 9.62969 0.280945 7 0.280945C4.37031 0.280945 2.21875 2.43251 2.21875 5.06219ZM10.6562 5.06219C10.6562 7.07313 9.01094 8.71844 7 8.71844C4.98906 8.71844 3.34375 7.07313 3.34375 5.06219C3.34375 3.05126 4.98906 1.40594 7 1.40594C9.01094 1.40594 10.6562 3.05126 10.6562 5.06219Z'
              stroke='#fff'
              strokeWidth='0.4'
              strokeLinejoin='round'
              fill='#fff'
            />
            <path
              d='M1.43047 14.9622C2.92109 13.4716 4.88984 12.6559 6.99922 12.6559C9.10859 12.6559 11.0773 13.4716 12.568 14.9622L13.3695 14.1606C11.668 12.4731 9.40391 11.5309 6.99922 11.5309C4.59453 11.5309 2.33047 12.4731 0.628906 14.1606L1.43047 14.9622Z'
              stroke='#fff'
              strokeWidth='0.4'
              strokeLinejoin='round'
              fill='#fff'
            />
          </svg>
          <Box color={'white'} fontSize={'0.7em'} marginLeft={'7px'}>
            {t('settings')}
          </Box>
        </MenuItem>
        <MenuItem
          onClick={handleLogout}
          sx={{
            '&:hover': {
              backgroundColor: ColorsV2.acent,
            },
          }}
        >
          <svg
            width='0.7em'
            height='0.7em'
            viewBox='0 0 16 18'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M5.19922 9.56812H15.9992'
              stroke='#F8FAFB'
              strokeWidth='1.5'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M8.425 1.16821H2.875C1.825 1.16821 1 1.99321 1 2.96821V16.0932C1 17.1432 1.825 17.9682 2.875 17.9682H8.425'
              stroke='#F8FAFB'
              strokeWidth='1.5'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M13.1504 6.71826L16.0004 9.56826L13.1504 12.4183'
              stroke='#F8FAFB'
              strokeWidth='1.5'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>

          <Box color={'white'} fontSize={'0.7em'} marginLeft={'7px'}>
            {t('logout')}
          </Box>
        </MenuItem>
        {adm === 'admin' && (
          <MenuItem>
            <Typography fontSize={'0.7em'} marginLeft={'7px'}>
              {t('switch_role')} :
            </Typography>
            <TextField
              select
              size='small'
              defaultValue={
                roles.find(role => accountSettings?.role === role.id)?.name || t('role_not_found')
              }
              onChange={handleChange}
              InputProps={{
                style: {
                  color: ColorsV2.white,
                  fontFamily: 'DM Sans, sans-serif',
                  fontSize: '0.7em',
                  fontWeight: '400',
                  lineHeight: '21px',
                  borderRadius: '8px',
                  height: '2.7em',
                },
              }}
              sx={{
                margin: '0px 0px 3px 0px',
                backgroundColor: 'transparent',

                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: ColorsV2.white,
                },
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': {
                    borderColor: ColorsV2.white,
                  },
                },

                '& label.Mui-focused': {
                  color: ColorsV2.white,
                  transform: 'translate(15px, -16px)',
                  fontSize: '0.75rem',
                },
                '&  .MuiFormHelperText-root.Mui-error': {
                  background: ColorsV2.secondary,
                  color: '#FF2800',
                  width: '101%',
                  height: '100%',
                  fontSize: '1rem',
                  marginTop: '-0.1%',
                  marginLeft: -0.15,
                  '.MuiSvgIcon-root ': {
                    fill: 'red',
                  },
                },
                '.MuiSvgIcon-root ': {
                  fill: 'white',
                },
              }}
              name='role'
              inputProps={{
                MenuProps: {
                  MenuListProps: {
                    sx: {
                      backgroundColor: ColorsV2.secondary,
                      color: 'white',
                      border: `2px solid ${ColorsV2.white}`,
                      '& .MuiMenuItem-root.Mui-selected': {
                        backgroundColor: ColorsV2.acent,
                        borderRadius: '8px',
                      },
                      '& .MuiMenuItem-root:hover': {
                        backgroundColor: ColorsV2.acent,
                        borderRadius: '8px',
                      },
                      '& .MuiMenuItem-root.Mui-selected:hover': {
                        backgroundColor: ColorsV2.acent,
                        borderRadius: '8px',
                      },
                    },
                  },
                },
              }}
            >
              {roles.map(role => (
                <MenuItem key={role.id} value={role.name}>
                  {role.name}
                </MenuItem>
              ))}
            </TextField>
          </MenuItem>
        )}
      </StyledMenu>
    </div>
  );
}
